import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import PerfectScrollbar from 'perfect-scrollbar';

@Directive({
    selector: '[perfectScrollbar]',
    standalone: true,
})
export class PerfectScrollbarDirective implements AfterViewInit, OnDestroy {
  @Input() perfectScrollbar: any;

  private instance: { destroy(): void } | null = null;

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.instance = new PerfectScrollbar(this.elementRef.nativeElement, {
        suppressScrollX: true,
        ...(this.perfectScrollbar || {}),
      });
    }
  }

  ngOnDestroy(): void {
    if (this.instance) {
      this.instance.destroy();
      this.instance = null;
    }
  }
}